
import {useState,useEffect} from 'react'
import {useNavigate} from "react-router-dom";
import SendData from "./SendData"

import socket from './../socket.js'

//import GetCode from "./GetCode";

function SystemSetting (){
  const [phone,setPhone] = useState ("");
  const navigate = useNavigate ();
  useEffect (()=>{
    if (!socket)return;
    /*
    socket.on ('message',(data)=>{
          if (JSON.parse(data).event=="NAME")navigate ("/NameSetting",{state:{name:JSON.parse(data).data.name}});

          if (JSON.parse(data).event=="phone_undefined")window.alert('شماره وارد شده نا معتبر می باشد')
          if (JSON.parse(data).event=="code_send")
          {
            navigate ("/GetCode",{state:{phone:JSON.parse(data).data.phone}});
          }
      });
      */
//    socket.on ('message',(data)=>{
//      if (data.event==='phone_undefined')window.alert('شماره وارد شده نا معتبر می باشد')
//      if (data.event==='code_send') window.alert(data.data);
//    });
  return () =>{
    socket.off ('message');
  };
},[socket]);

  return (
    <div>
    <div style={style.container}>
      <div style={style.content}>
      <button className="btn"
        onClick ={()=>{
          socket.off ('message');
          socket.on ('message',(data)=>{
            if (JSON.parse(data).event=="NAME")navigate ("/NameSetting",{state:{name:JSON.parse(data).data.name}});
          });
          SendData (socket,'data',{"event":"get_name"});
        }}>
         تنظیم نام سیستم
      </button>
      <button className="btn"
        onClick ={()=>{
          socket.off ('message');
          socket.on ('message',(data)=>{
            if (JSON.parse(data).event=="MENU_CONFIG")navigate ("/ConfigSetting",{state:JSON.parse(data).data});
          });
          SendData (socket,'data',{"event":"get_menu_config"});
        }}>
          پیکره بندی
      </button>
      <button className="btn"
        onClick ={()=>{
          socket.off ('message');
          socket.on ('message',(data)=>{
            if (JSON.parse(data).event=="PHONES")navigate ("/PhoneSetting",{state:JSON.parse(data).data});
          });
          SendData (socket,'data',{"event":"get_phones"});
        }}>
          تنظیمات شماره تلفن ها
      </button>
      <button className="btn"
        onClick ={()=>{
          socket.off ('message');
          socket.on ('message',(data)=>{
            if (JSON.parse(data).event=="MENU_ERR")navigate ("/ErrorSetting",{state:JSON.parse(data).data});
          });
          SendData (socket,'data',{"event":"get_menu_err"});
        }}>
          تنظیم خطا ها
      </button>
      <button className="btn"
        onClick ={()=>{
          socket.off ('message');
          socket.on ('message',(data)=>{
            if (JSON.parse(data).event=="MENU_WINDOW")navigate ("/WindowSetting",{state:JSON.parse(data).data});
          });
          SendData (socket,'data',{"event":"get_menu_window"});
        }}>
          تنظیمات پنجره ها
      </button>
      <button className="btn"
        onClick ={()=>{
          socket.off ('message');
          socket.on ('message',(data)=>{
            if (JSON.parse(data).event=="MENU_MANDATORY")navigate ("/MandatorySetting",{state:JSON.parse(data).data});
          });
          SendData (socket,'data',{"event":"get_menu_mandatory"});
        }}>
          هوا دهی اجباری
      </button>


      </div>
      </div>
      <button   style={{marginTop:100}}
        onClick ={()=>{
          localStorage.clear ();
          navigate (-3);
        }}>
         خروج
      </button>
    </div>

  );


}
const style={
  container:{
  //  minHeight:"100vh",
    display:"flex",
    alignItems:"center",
    padding:16,
//    backgroundColor:"#00f7f7"
  },
  content:{

    width:"100%",
    maxWidth:420,
    display:"flex",
    flexDirection:"column",
    gap:12,
    marginTop:10
  },
  input:{
    width:"90%",
    maxWidth:420,
    padding:14,
    fontSize:16,
    borderRadius:8,
//    border:"1px solid #ccc"
  },
  button:{
    width:"100%",
    maxWidth:420,
    padding:14,
    fontSize:16,
    borderRadius:8,
    border:"nune",
    backgroundColor:"#1976d2",
    coloe:"#fff",
    cursor:"pointer"
  },
  text:{
    alignItems:"center",
    textAlign:"center",
    width:"90%",
    padding:14,
    fontSize:24,
    borderRadius:8,
    border:"nune",
  //  backgroundColor:"#1976d2",
    coloe:"#fff",
//    cursor:"pointer"
  }

}

export default SystemSetting;
